import React from 'react'
//import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types'
import { Grommet } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import styled from 'styled-components';
import Header_index from "../components/Header_index";
import Footer from "../components/Footer";
import PageLogin from "../components/PageLogin";
import '../styles/styles.css';
// const Hello = props => (
//   <div>Hello {props.name}!</div>
// )

// Hello.defaultProps = {
//   name: 'David'
// }

// Hello.propTypes = {
//   name: PropTypes.string
// }


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <>
  <Grommet theme={hpe} full> 
    <Header_index name="Smart IRD"/>
    <PageLogin   />
    <Footer />
  </Grommet>  
  </>
  );